//#region IMPORTS
import React, { Component } from "react";
import { Fstyr } from "../../components/FstyrComponents/Fstyr.js";
import URL from "../../Constants/URL.js";
import { DateFormatter } from "../../components/HelperComponents/DateFormatter";
import { GetStatusVm, GetStatusId, GetStatusName } from "../../components/HelperComponents/StatusHelper";
import { fetchModel } from "../../components/HelperComponents/FetchExtension";
import { DriverCardVm } from "../../Models/DriverCardVm";
import { filterCardStatuses, filterCardStatusesPolice } from "../../components/HelperComponents/FilterCardStatuses.js";
import { ValidationType } from "../../Constants/ValidationTypes";
import { formatAddress } from "../../components/HelperComponents/AddressFormatter.js";
import { cardNumberFromHRef } from "../../components/HelperComponents/GetCardNumberFromHRef.js";

//#endregion

//#region CLASS/CONSTRUCTOR/STATE

type Props = {};

type State = {
  cardFound: boolean;
  cardNumberInput: string;
  showStatusChange: boolean;
  showSpinner: boolean;

  newCardStatusId: number;
  newCardStatusRemark: string;

  driverCardVm: DriverCardVm;

  //ButtonPressChecks
  searchButtonPressed: boolean;

  //Validation
  cardNumberIsValid: boolean;
};

export class SearchCard extends Component<Props, State> {
  static displayName = SearchCard.name;
  private toastRef: React.RefObject<any>;
  private baseState: State;

  constructor(props: Props) {
    super(props);
    this.toastRef = React.createRef();

    this.state = {
      cardFound: false,
      cardNumberInput: cardNumberFromHRef(),
      showStatusChange: false,
      showSpinner: false,

      newCardStatusId: 0,
      newCardStatusRemark: "",

      driverCardVm: new DriverCardVm(),

      //ButtonPressChecks
      searchButtonPressed: false,

      //Validation
      cardNumberIsValid: false,
    };
    this.baseState = this.state;
  }

  componentDidMount() {
    this.setState({ cardNumberInput: cardNumberFromHRef() }, () => {
      if (this.state.cardNumberInput.length === 16) {
        this.searchDriverCard();
      }
    });
  }
  componentDidUpdate() {
      console.log(this.state)
  }

  //#endregion

  //#region API CALLS

  searchDriverCard() {
    this.setState({ searchButtonPressed: true }, () => {
      if (this.state.cardNumberIsValid) {
        this.clearPage(false);
        this.setState({ showSpinner: true });

        this.searchDriverCardFromDK();
      }
    });
  }

  async searchDriverCardFromDK() {
    var dkCardFound = false
    await fetchModel("GET", URL + "/api/drivercard/GetDriverCard", this.state.cardNumberInput, DriverCardVm)
        .then(model => {
            if (model.length > 0) {
                var drivercard = model[0]
                this.setState({ driverCardVm: drivercard, cardFound: true })
                dkCardFound = true
            }
        })
        .catch((error) => {
            this.showErrorToast(error, "et førerkort")
        }).finally(() => { this.setState({ showSpinner: false }) })
    return dkCardFound
}

  changeCardStatus() {
    let model = this.state.driverCardVm;
    model.Status = GetStatusVm(this.state.newCardStatusId);
    model.Remark = this.state.newCardStatusRemark;

    let success = true;
    let requestInfo = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(model),
    };
    fetch(URL + "/api/drivercard/ChangeCardStatus", requestInfo)
      .then((response) => response.json())
      .then((result) => {
        if (!result.valid) {
          success = false;
        }
        this.searchDriverCard();
      })
      .catch(() => {
        success = false;
      })
      .finally(() => {
        success ? this.toastRef.current.show("Skift status", "Kortets status er skiftet.", "success") : this.toastRef.current.show("Skift status", "Kortets status blev ikke skiftet.", "error");
      });
  }

  //#endregion

  //#region GUI EVENTS

  clearPage(clearInput: boolean) {
    if (clearInput) {
      this.setState(this.baseState);
    } else {
      this.setState({
        cardFound: false,
        showStatusChange: false,
        showSpinner: false,

        newCardStatusId: 0,
        newCardStatusRemark: "",

        driverCardVm: new DriverCardVm(),
      });
    }
  }

  showErrorToast(error: string, message: string) {
    this.setState({ showSpinner: false });
    if (error === "No result") {
      this.toastRef.current.show("Førerkort", "Der findes ikke " + message + " med det søgte nummer", "warning");
    } else if (error === "Failed response") {
      this.toastRef.current.show("Fejl", "Kan ikke forbinde til databasen", "error");
    } else if (message === "changeCardStatus") {
      this.toastRef.current.show("Fejl", "Kan ikke skifte status på det søgte førerkort", "error");
    } else {
      this.toastRef.current.show("Fejl", "Der skete en ukendt fejl", "error");
    }
  }

  //#endregion

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toastRef} />
        <Fstyr.Segment title="Søg Førerkort" isPageTitle={true}>
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button label="Ryd side" onClick={() => this.clearPage(true)} />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment title="Angiv kortnummer">
          <Fstyr.Input
            value={this.state.cardNumberInput}
            label="Kortnummer"
            onChange={(value: string) => this.setState({ cardNumberInput: value })}
            validation={true}
            validationType={ValidationType.cardNumber}
            errorBodyText={"Forkert format (landekode + 14 tegn)"}
            errorExampleText={"f.eks. DK00000050121001"}
            onEnterPressed={() => this.searchDriverCard()}
            setValid={(valid: boolean) => this.setState({ cardNumberIsValid: valid })}
            buttonClicked={this.state.searchButtonPressed}
            onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
          />
          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => {
                this.searchDriverCard();
              }}
              disabled={this.state.showSpinner}
            />
            <Fstyr.Spinner show={this.state.showSpinner} />
          </div>
        </Fstyr.Segment>

        <Fstyr.Segment title="Førerkortinformation">
          <div className="fstyr-attention-box">
            <p>Førerkort</p>
            <Fstyr.Input label="Kortnummer" readonly={true} value={this.state.driverCardVm.CardNumber} direction="row" />
            <Fstyr.Input label="Gyldighedsperiode" readonly={true} value={this.state.cardFound ? DateFormatter(this.state.driverCardVm.ValidFrom) + "  -  " + DateFormatter(this.state.driverCardVm.ValidTo) : ""} direction="row" />
            <Fstyr.Input label="Kortholder (fører)" readonly={true} value={this.state.driverCardVm.Person.FirstName + " " + this.state.driverCardVm.Person.LastName} direction="row" />
            <Fstyr.Input label="CPR" readonly={true} value={this.state.driverCardVm.Person.Cpr} direction="row" />
            <Fstyr.Input label="Adresse" readonly={true} value={formatAddress(this.state.driverCardVm.Person.Address, true)} direction="row" />
            <Fstyr.Input label="Kørekortnummer" readonly={true} value={this.state.driverCardVm.Person.DriverLicense.Number} direction="row" />
            <Fstyr.Input label="Status på kort" readonly={true} direction="row" value={this.state.cardFound ? GetStatusName(this.state.driverCardVm.Status.Id) : ""} />
            <Fstyr.Input label="Bemærkning" readonly={true} direction="row" value={this.state.driverCardVm.Remark} />
            <Fstyr.Button
              label="Skift status"
              onClick={() => {
                this.setState({ showStatusChange: true });
              }}
              disabled={!this.state.cardFound}
            />

            {this.state.showStatusChange && (
              <div className="alert alert-info" style={{ marginTop: 10, maxWidth: 360 }}>
                <div className="alert-body" style={{ height: "100%" }}>
                  <p className="alert-heading">Ekstra oplysninger</p>
                  <p className="alert-text">Udfyld de nedenstående oplysninger.</p>
                  <Fstyr.Dropdown items={global.config.isPolice ? filterCardStatusesPolice(require("../../assets/CardStatus.json")) : filterCardStatuses(require("../../assets/CardStatus.json"))} onItemSelected={(status) => this.setState({ newCardStatusId: GetStatusId(require("../../assets/CardStatus.json"), status) })} label="Ny status" />
                  <Fstyr.Input label="Begrundelse for ændring" direction="column" value={this.state.newCardStatusRemark} onChange={(value: string) => this.setState({ newCardStatusRemark: value })} />
                  <Fstyr.Input label="Dato for ændring" direction="column" readonly={true} value={DateFormatter(new Date())} />
                  <div className="fstyr-right-button-group">
                    <Fstyr.Button
                      label="Gem"
                      onClick={() => {
                        this.changeCardStatus();
                      }}
                      disabled={this.state.newCardStatusId === this.baseState.newCardStatusId}
                    />
                    <Fstyr.Button
                      label="Annullér"
                      type="secondary"
                      onClick={() =>
                        this.setState({
                          showStatusChange: false,
                          newCardStatusId: 0,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </Fstyr.Segment>
      </>
    );
  }
}
